import React, { useState } from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage, handleError } from '../../utils/lib';
import ListItemWAvatar from '../../layouts/ListItemWAvatar';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from '../../providers/SnackBarProvider';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const SearchSymptom = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const snackbar = useSnackbar();
  
  const [openDialog, setOpenDialog] = useState(false);
  const [newSymptom, setNewSymptom] = useState({ name: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  
  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemWAvatar 
        key={item.id} 
        primary={item.name}
      />
    </Box>
  );

  const handleOnClick = (symptom) => {
    const from = location.state?.from;
    const pet = location.state?.pet;
    if (from) {
      navigate(from, { state: { symptom, pet }, replace: true });
    }
  };

  const handleCreateNew = () => {
    setNewSymptom({ name: '' });
    setErrors({});
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (!isLoading) {
      setOpenDialog(false);
    }
  };

  const handleSaveSymptom = async () => {
    if (!newSymptom.name.trim()) {
      setErrors({ name: t('search.nameRequired') });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}symptoms`,
        newSymptom,
        { withCredentials: true }
      );

      newSymptom.id = response.data.data.id;
      
      setOpenDialog(false);
      
      // Si viene de otra página, navegar de vuelta con el síntoma creado
      const from = location.state?.from;
      const pet = location.state?.pet;
      if (from) {
        navigate(from, { state: { symptom: newSymptom, pet }, replace: true });
      }
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <SearchPage
        fetchFunction={fetchSearchPage}
        table={'symptoms'}
        renderItem={renderItem}
        placeholder={t('search.searchSymptom')}
        createNew={handleCreateNew}
      />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t('search.newSymptom')}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="normal"
            label={t('common.nameStar')}
            value={newSymptom.name}
            onChange={(e) => {
              setNewSymptom({ ...newSymptom, name: e.target.value });
              if (errors.name) setErrors({});
            }}
            error={!!errors.name}
            helperText={errors.name}
            disabled={isLoading}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSaveSymptom();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isLoading}>
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleSaveSymptom}
            variant="contained"
            color="primary"
            disabled={isLoading || !newSymptom.name.trim()}
            startIcon={isLoading ? <CircularProgress size={20} /> : null}
          >
            {isLoading ? t('common.saving') : t('common.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchSymptom;

